import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Path 2494",
  "use": "icon-Path 2494-usage",
  "viewBox": "0 0 7.191 12.261",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 7.191 12.261\" id=\"icon-Path 2494\">\n  <path id=\"icon-Path 2494_Path_2494\" data-name=\"Path 2494\" d=\"M293.116,2184.685l-5.07,5.07,5.07,5.07\" transform=\"translate(294.177 2195.885) rotate(180)\" fill=\"none\" stroke=\"#fff\" stroke-linecap=\"round\" stroke-width=\"1.5\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/Path 2494.svg
// module id = Zk5H
// module chunks = 3